module.exports = __webpack_public_path__ + "img/3-rectangle-6-copy-10@2x.d381dcad.png";